 import { apiUrl as baseApiUrl} from "../apiendpoint";


import simpleRestProvider from "ra-data-simple-rest";
import { fetchUtils } from "react-admin";

const apiUrl = baseApiUrl.replace(/\/$/, "");

const httpClient = (url, options = {}) => {
  const token = localStorage.getItem("access_token");

  options.headers =
    options.headers ||
    new Headers({
      Accept: "application/json",
    });

  if (token) {
    options.headers.set("Authorization", `Bearer ${token}`);
  }

  return fetchUtils.fetchJson(url, options);
};

const baseDataProvider = simpleRestProvider(apiUrl, httpClient);

const DataProvider = {
  ...baseDataProvider,

// getList: (resource, params) => {

//   console.log("RAW getList Resource:", resource);

//   // ✅ CUSTOM for assignments
//   if (resource === "assignments") {
//     const { page, perPage } = params.pagination;

//     const query = {
//       range: JSON.stringify([
//         (page - 1) * perPage,
//         page * perPage - 1,
//       ]),
//       sort: JSON.stringify(params.sort),
//       filter: JSON.stringify(params.filter),
//     };

//     const url = `${apiUrl}/${resource}?${new URLSearchParams(query)}`;

//     return httpClient(url).then(({ json }) => {
//       return {
//         data: json.data,
//         total: json.total,
//       };
//     });
//   }

//   // ✅ DEFAULT + SAFE unwrap
//   return baseDataProvider.getList(resource, params).then((response) => {

//     console.log("DEFAULT RESPONSE:", response);

//     // 🔥 Fix nested APIs globally
//     if (response.data?.data && Array.isArray(response.data.data)) {
//       return {
//         data: response.data.data,
//         total: response.data.total || response.data.data.length,
//       };
//     }

//     // 🔥 Ensure always array
//     if (!Array.isArray(response.data)) {
//       return {
//         data: [],
//         total: 0,
//       };
//     }

//     return response;
//   });
// },


getOne: (resource, params) => {

  // ✅ CUSTOM getOne for all_responses
  if (resource === "all_responses") {

    const url = `${apiUrl}/attempts/${params.id}/result`;

    return httpClient(url).then(({ json }) => {

      return {
        data: {
          id: json.attempt_id, // ✅ REQUIRED
          ...json,
        },
      };
    });
  }

  // ✅ default
  return baseDataProvider.getOne(resource, params);
},


getList: (resource, params) => {

  console.log("RAW getList Resource:", resource);

  // ✅ CUSTOM for assignments
  if (resource === "assignments") {
    const { page, perPage } = params.pagination;

    const query = {
      range: JSON.stringify([
        (page - 1) * perPage,
        page * perPage - 1,
      ]),
      sort: JSON.stringify(params.sort),
      filter: JSON.stringify(params.filter),
    };

    const url = `${apiUrl}/${resource}?${new URLSearchParams(query)}`;

    return httpClient(url).then(({ json }) => {
      return {
        data: json.data,
        total: json.total,
      };
    });
  }

  // ✅ CUSTOM for all_responses
  if (resource === "all_attempts") {

    const url = `${apiUrl}/${resource}`;

    return httpClient(url).then(({ json }) => {

      return {
        data: json.map((item) => ({
          id: item.attempt_id, // REQUIRED by react-admin
          ...item,
        })),
        total: json.length,
      };
    });
  }

  // ✅ DEFAULT + SAFE unwrap
  return baseDataProvider.getList(resource, params).then((response) => {

    console.log("DEFAULT RESPONSE:", response);

    // 🔥 Fix nested APIs globally
    if (response.data?.data && Array.isArray(response.data.data)) {
      return {
        data: response.data.data,
        total: response.data.total || response.data.data.length,
      };
    }

    // 🔥 Ensure always array
    if (!Array.isArray(response.data)) {
      return {
        data: [],
        total: 0,
      };
    }

    return response;
  });
},





// create: (resource, params) => {
//   // ✅ Handle file upload resources
//   if (resource === "certificate" || resource === "user-guides") {

//     const formData = new FormData();

//     Object.keys(params.data).forEach((key) => {
//       if (key === "file" && params.data.file?.rawFile) {
//         formData.append("file", params.data.file.rawFile);
//       } else {
//         formData.append(key, params.data[key]);
//       }
//     });

//     return httpClient(`${apiUrl}/${resource}`, {
//       method: "POST",
//       body: formData,
//       // 🚨 DO NOT SET CONTENT-TYPE
//     }).then(({ json }) => ({
//       data: json,
//     }));
//   }

//   // ✅ All other resources normal JSON
//   return baseDataProvider.create(resource, params).then((response) => {
//     const record = response.data.data ?? response.data;
//     return { data: record };
//   });
// },
create: (resource, params) => {
  if (resource === "certificate" || resource === "user-guides") {
    const formData = new FormData();

    Object.keys(params.data).forEach((key) => {
      if (key === "file" && params.data.file?.rawFile) {
        formData.append("file", params.data.file.rawFile);
      } else {
        formData.append(key, params.data[key]);
      }
    });

    return httpClient(`${apiUrl}/${resource}`, {
      method: "POST",
      body: formData,
    }).then(({ json }) => ({
      data: {
        id: json.id ?? Math.random(), // ✅ FIX
        ...json,
      },
    }));
  }

  return baseDataProvider.create(resource, params).then((response) => {
    const record = response.data.data ?? response.data;
    console.log("Created record:", record); 
    return {
      data: {
        id: record.id, // ✅ FIX
        ...record,
      },
    };
  });
},
update: (resource, params) => {
  console.log("UPDATE CALLED:", resource, params); // 🔥 debug

  return httpClient(`${apiUrl}/${resource}/${params.id}`, {
    method: "PUT", // or PATCH if your backend uses it
    body: JSON.stringify({
      ...params.data,
      permission_ids: params.data.permission_ids || [],
    }),
  }).then(({ json }) => {
    console.log("UPDATE RESPONSE:", json); // 🔥 debug

    const data = json.data ?? json;

    return {
      data: {
        id: params.id, // ✅ REQUIRED
        ...data,
      },
    };
  });
},
  deleteMany: (resource, params) =>
    httpClient(
      `${apiUrl}/${resource}?ids=${params.ids.join(",")}`,
      { method: "DELETE" }
    ).then(() => ({
      data: params.ids,
    })),
};


export default DataProvider;
